import React from "react";
import styles from "./index.module.scss";
import MyDropdown from "../../../../../Common/my-dropdown/my-dropdown-new.component";
import ThreeDotsIcon from "../../../../../icons/three-dots.icon";

interface MoreOptionsMenuProps {
  onDuplicate?: () => void;
  onDelete?: () => void;
}

const MoreOptionsMenu: React.FC<MoreOptionsMenuProps> = ({
  onDuplicate,
  onDelete,
}) => {
  return (
    <MyDropdown onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <MyDropdown.Toggle hideArrow>
        <div className={styles.moreOptionsButton}>
          <ThreeDotsIcon />
        </div>
      </MyDropdown.Toggle>
      <MyDropdown.Menu popperConfig={{ strategy: "fixed" }} renderOnMount>
        <MyDropdown.Item onClick={onDuplicate}>
          Duplicate
        </MyDropdown.Item>
        <MyDropdown.Item onClick={onDelete} className="f-red">
          Delete
        </MyDropdown.Item>
      </MyDropdown.Menu>
    </MyDropdown>
  );
};

export default MoreOptionsMenu;

